var _rect, _path, _path2, _path3, _path4, _path5, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDtFeeder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 37,
    rx: 5,
    fill: "url(#paint0_linear_224_748)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.6083 28.625H23.3535L22.8952 27.25H14.5714L14.1131 28.625H11.8583C11.4784 28.625 11.1708 28.9326 11.1708 29.3125C11.1708 29.6924 11.4784 30 11.8583 30H25.6083C25.9882 30 26.2958 29.6924 26.2958 29.3125C26.2958 28.9326 25.9882 28.625 25.6083 28.625Z",
    fill: "url(#paint1_linear_224_748)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6083 12.125C25.2289 12.125 24.9208 12.4331 24.9208 12.8125C24.9208 13.1919 25.2289 13.5 25.6083 13.5C25.9877 13.5 26.2958 13.1919 26.2958 12.8125C26.2958 12.4331 25.9877 12.125 25.6083 12.125Z",
    fill: "url(#paint2_linear_224_748)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3583 8H9.0625C7.92526 8 7 8.92526 7 10.0625V21.75H11.1708V19.6875C11.1708 19.3076 11.4784 19 11.8583 19H12.9206C12.9916 18.8 13.0729 18.6038 13.1649 18.4111L12.4135 17.6592C12.145 17.3906 12.145 16.9556 12.4135 16.687L14.3579 14.7427C14.6264 14.4741 15.0615 14.4741 15.33 14.7427L16.082 15.4946C16.2746 15.4026 16.4707 15.3208 16.6708 15.2495V14.1875C16.6708 13.8076 16.9784 13.5 17.3583 13.5H20.1083C20.4882 13.5 20.7958 13.8076 20.7958 14.1875V15.2497C20.9958 15.3208 21.192 15.4028 21.3847 15.4946L22.1366 14.7427C22.4052 14.4743 22.8403 14.4743 23.1088 14.7427L25.0531 16.687C25.3217 16.9556 25.3217 17.3908 25.0531 17.6592L24.3017 18.4111C24.3938 18.604 24.475 18.8 24.5461 19H25.6083C25.9882 19 26.2958 19.3076 26.2958 19.6875V21.75H30.4667V10.0625C30.4667 8.92526 29.4956 8 28.3583 8ZM25.6083 14.875C24.4711 14.875 23.5458 13.9497 23.5458 12.8125C23.5458 11.6753 24.4711 10.75 25.6083 10.75C26.7456 10.75 27.6708 11.6753 27.6708 12.8125C27.6708 13.9497 26.7456 14.875 25.6083 14.875Z",
    fill: "url(#paint3_linear_224_748)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6708 21.0625C16.6708 21.3001 16.7256 21.5292 16.8042 21.75H20.6624C20.741 21.5292 20.7958 21.3001 20.7958 21.0625C20.7958 19.9253 19.8705 19 18.7333 19C17.5959 19 16.6708 19.9253 16.6708 21.0625Z",
    fill: "url(#paint4_linear_224_748)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0939 19.8594C14.0155 20.1628 13.7416 20.375 13.4279 20.375H12.5458V21.75H15.3862C15.34 21.5235 15.2958 21.296 15.2958 21.0625C15.2958 19.1672 16.838 17.625 18.7333 17.625C20.6286 17.625 22.1708 19.1672 22.1708 21.0625C22.1708 21.296 22.1266 21.5235 22.0804 21.75H24.9208V20.375H24.0387C23.725 20.375 23.4511 20.1628 23.3726 19.8594C23.2631 19.4331 23.0919 19.0208 22.8636 18.634C22.7045 18.3642 22.7482 18.0205 22.9696 17.7988L23.5948 17.1731L22.6227 16.2009L21.9969 16.8267C21.7753 17.049 21.4308 17.0933 21.161 16.9321C20.775 16.7046 20.3634 16.5327 19.9364 16.4231C19.6329 16.3447 19.4208 16.0708 19.4208 15.7571V14.875H18.0458V15.7571C18.0458 16.0708 17.8336 16.3447 17.5302 16.4231C17.1031 16.5327 16.6915 16.7046 16.3055 16.9321C16.037 17.0933 15.6918 17.049 15.4696 16.8267L14.8439 16.2009L13.8717 17.1731L14.4969 17.7988C14.7184 18.0205 14.7621 18.3642 14.6029 18.634C14.3746 19.0208 14.2035 19.4331 14.0939 19.8594Z",
    fill: "url(#paint5_linear_224_748)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7 23.8125C7 24.9497 7.92526 25.875 9.0625 25.875H28.3583C29.4956 25.875 30.4667 24.9497 30.4667 23.8125V23.125H7V23.8125Z",
    fill: "url(#paint6_linear_224_748)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_224_748",
    x1: 0,
    y1: 0,
    x2: 37,
    y2: 37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C4B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70EFDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_224_748",
    x1: 25.2234,
    y1: 27.7466,
    x2: 8.88316,
    y2: 30.6768,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_224_748",
    x1: 26.1983,
    y1: 12.3733,
    x2: 24.6667,
    y2: 12.4232,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_224_748",
    x1: 28.8029,
    y1: 10.483,
    x2: 2.71624,
    y2: 11.9346,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_224_748",
    x1: 20.5033,
    y1: 19.4966,
    x2: 15.9145,
    y2: 19.721,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_224_748",
    x1: 24.0434,
    y1: 16.1165,
    x2: 10.2915,
    y2: 16.9236,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_224_748",
    x1: 28.8029,
    y1: 23.6216,
    x2: 4.51553,
    y2: 30.3789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDtFeeder);
export default __webpack_public_path__ + "static/media/dt-feeder.072358ced05799d35f64ef2c9b630c1c.svg";
export { ForwardRef as ReactComponent };